export const URL="https://landes-location.com/"

export const  URL_Back=" https://admin.landes-location.com/api"


export const API_KEY = 'a2b18f9cfb72eb93f3ce6b1c30372b59';
